module.exports = __webpack_public_path__ + "img/MC3300x.44f13407.jpg";